import $ from 'jquery';
import Discounts from "../service/Discounts";

let debounce;
$('body').on('input', '#basket-coupon', function (e) {
    clearTimeout(debounce);
    e.preventDefault();
    e.stopPropagation();

    const coupon = $('#basket-coupon').val();
    const containerCoupons = $('.cart-applied-coupons');
    if (coupon !== '') {
        debounce = setTimeout(() => {
            Discounts.set(coupon).then((response) => {
                if (response.msg_bool) {
                    containerCoupons.append("<div class=\"cart-applied-coupons__coupon mb--10\">" + coupon + "<span class=\"cart-applied-coupons__coupon--delete\"></span></div>");
                    $('#basket-coupon').val('')
                    window.location.reload();
                } else {
                    $('.cart-applied-coupons__error').html(response.title);
                    $('#basket-coupon').css('border', '1px solid #ed1b2f');
                }
            }).catch((XMLHttpRequest, textStatus, errorThrown) => {
                console.log("Status: " + textStatus);
                console.log("Error: " + errorThrown);
                //alert("Error: " + errorThrown);
            });
        }, 300);
    }

    $('.cart-applied-coupons__error').html('');
    $('#basket-coupon').removeAttr('style');
});

$('body').on('click', '.cart-applied-coupons__coupon--delete', function() {
    const couponElement = $(this).parent();
    const coupon = couponElement.text().trim();

    Discounts.delete(coupon).then((response) => {
        couponElement.remove();
        window.location.reload();
    }).catch((XMLHttpRequest, textStatus, errorThrown) => {
        console.log("Status: " + textStatus);
        console.log("Error: " + errorThrown);
        //alert("Error: " + errorThrown);
    });
});